export default __webpack_public_path__ + "static/assets/tram.dcb7fd4a5b2f3263d58ba10b3392f3a4.png";